export const keys= {
    USER : "CURRENT_USER",
    PLOTS: "PLOTS",
    YEARS: "YEARS",
    SETTINGS: "SETTINGS",
    DEVICE: "DEVICE",
    YEAR: "CURRENT_YEAR",
    PLOT: "CURRENT_PLOT",
    NEXTID: "NEXTID",
    UNSAVED: "UNSAVED",
    VISIT: "CURRENT_VISIT",
    VALUES: "CURRENT_VALUES",
    SHORTLIST: "SHORTLIST"
}

const localStorageService = (function(){

    function _getItem(item) {
        item= `${parseInt(process.env.REACT_APP_PROJECTID)}${item}`
        return JSON.parse(window.localStorage.getItem(item))
    }
    function _setItem(item, content) {
        item= `${parseInt(process.env.REACT_APP_PROJECTID)}${item}`
        try {
            window.localStorage.setItem(item, JSON.stringify(content))
        }
        catch (error) {
            console.log(item, error)
        }
    }
    function _removeItem(item) {
        item= `${parseInt(process.env.REACT_APP_PROJECTID)}${item}`
        window.localStorage.removeItem(item)
    }

    return {
        getItem: _getItem,
        setItem: _setItem,
        removeItem: _removeItem
    }
}) ();

export default localStorageService;

